module.exports = __webpack_public_path__ + "media/images/iconEdit__accent-8892bd24cbfd33b3f2a66bb7e663a394.png";